var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "video__object__info",
      attrs: { "data-ui-section": "video-info" }
    },
    [
      _c("div", { staticClass: "video__object__info__synopsis" }, [
        _c(
          "div",
          { staticClass: "row" },
          [
            _c("div", { staticClass: "col-md-12 col-xl-8" }, [
              _c(
                "div",
                { staticClass: "d-flex justify-content-between mb-md-3" },
                [
                  _c("h3", [_vm._v(_vm._s(_vm.title))]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "vs-btn-legacy d-block d-md-none",
                      on: { click: _vm.clickArrow }
                    },
                    [
                      _c("i", { staticClass: "large material-icons" }, [
                        _vm._v(_vm._s(_vm.arrowDirection))
                      ])
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _vm.subtitle
                ? _c("h3", [
                    _vm._v("\n          " + _vm._s(_vm.subtitle) + "\n        ")
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("ContentRatingBlock", {
              staticClass: "col-12",
              attrs: { video: _vm.video }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "row",
            class: [!_vm.isCollapsed && "d-none d-md-flex"]
          },
          [
            _c("div", { staticClass: "col-xl-8 col-md-8 mb-4" }, [
              _c("div", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isCollapsed,
                    expression: "isCollapsed"
                  }
                ],
                staticClass:
                  "video__object__info__static__synopsis stylized d-md-block",
                domProps: { innerHTML: _vm._s(_vm.processedDescriptionHTML) }
              }),
              _vm._v(" "),
              _c(
                "h3",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.video.directorStatement != null &&
                        _vm.video.directorStatement !== "" &&
                        _vm.isCollapsed,
                      expression:
                        "video.directorStatement !=null && video.directorStatement !== '' && isCollapsed"
                    }
                  ],
                  staticClass: "divider"
                },
                [_vm._v("\n          Director's statement\n        ")]
              ),
              _vm._v(" "),
              _c("div", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value:
                      _vm.video.directorStatement != null &&
                      _vm.video.directorStatement !== "" &&
                      _vm.isCollapsed,
                    expression:
                      "video.directorStatement !=null && video.directorStatement !== '' && isCollapsed"
                  }
                ],
                staticClass:
                  "video__object__info__static__synopsis stylized mb-4",
                domProps: {
                  innerHTML: _vm._s(_vm.processedDirectorStatementHTML)
                }
              }),
              _vm._v(" "),
              _c("div", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isCollapsed,
                    expression: "isCollapsed"
                  }
                ],
                staticClass: "video__object__info__static__festivals",
                class: _vm.showMoreFestivals ? "more" : "less",
                domProps: { innerHTML: _vm._s(_vm.video.festivals) }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-xl-4 col-md-4" }, [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isCollapsed,
                      expression: "isCollapsed"
                    }
                  ],
                  staticClass: "row d-md-flex",
                  style: { backgroundColor: "#EEEEEE" }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-md-6 col-6 py-4 video__object__info__links"
                    },
                    [
                      _c(
                        "ul",
                        {
                          staticClass: "video__object__info__credits stylized"
                        },
                        [
                          _c(
                            "li",
                            { staticClass: "video__object__info__credit" },
                            [
                              _c("h6", [
                                _vm._v(_vm._s(_vm.$t("video.info.country")))
                              ]),
                              _vm._v(" "),
                              _vm._l(
                                _vm.makeTagArray(
                                  "country",
                                  _vm.video.countries
                                ),
                                function(country) {
                                  return _c(
                                    "a",
                                    {
                                      key: country.id,
                                      staticClass: "a--hover",
                                      attrs: {
                                        href: country.url,
                                        "data-event-category": "discover",
                                        "data-event-action": "info",
                                        "data-event-label": country.name
                                      }
                                    },
                                    [_vm._v(_vm._s(country.name))]
                                  )
                                }
                              )
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _vm.video.languages && _vm.video.languages.length
                            ? _c(
                                "li",
                                { staticClass: "video__object__info__credit" },
                                [
                                  _c("h6", [
                                    _vm._v(
                                      _vm._s(_vm.$t("video.info.language"))
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _vm._l(
                                    _vm.makeTagArray(
                                      "language",
                                      _vm.video.languages
                                    ),
                                    function(language) {
                                      return _c(
                                        "a",
                                        {
                                          key: language.id,
                                          staticClass: "a--hover",
                                          attrs: {
                                            href:
                                              "/search?search_term=" +
                                              language.name,
                                            "data-event-category": "discover",
                                            "data-event-action": "info",
                                            "data-event-label": language.name
                                          }
                                        },
                                        [_vm._v(_vm._s(language.name))]
                                      )
                                    }
                                  )
                                ],
                                2
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.video.seriesSnippet
                            ? _c(
                                "li",
                                { staticClass: "video__object__info__credit" },
                                [
                                  _c("h6", [
                                    _vm._v(_vm._s(_vm.$t("video.info.series")))
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "a",
                                    {
                                      staticClass: "a--hover",
                                      attrs: {
                                        href:
                                          "/series/" +
                                          _vm.video.seriesSnippet.slug,
                                        "data-event-category": "discover",
                                        "data-event-action": "info",
                                        "data-event-label":
                                          _vm.video.seriesSnippet.title
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.video.seriesSnippet.title)
                                      )
                                    ]
                                  )
                                ]
                              )
                            : _vm._e()
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-6 col-6 py-4 " }, [
                    _c(
                      "ul",
                      { staticClass: "video__object__info__credits stylized" },
                      [
                        _c(
                          "li",
                          { staticClass: "video__object__info__credit" },
                          [
                            _c("h6", [
                              _vm._v(_vm._s(_vm.$t("video.info.rating")))
                            ]),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass:
                                  "a--hover d-flex align-items-center"
                              },
                              [
                                _vm.roundedReviewScore !== "-"
                                  ? _c("img", {
                                      staticClass: "mr-2",
                                      attrs: {
                                        src: require("@/images/star.png"),
                                        alt: "review-star-icon",
                                        width: "12",
                                        height: "12"
                                      }
                                    })
                                  : _vm._e(),
                                _vm._v(_vm._s(_vm.roundedReviewScore))
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "li",
                          { staticClass: "video__object__info__credit" },
                          [
                            _c("h6", [
                              _vm._v(_vm._s(_vm.$t("video.info.genre")))
                            ]),
                            _vm._v(" "),
                            _vm._l(
                              _vm.makeTagArray("genre", _vm.video.genres),
                              function(genre) {
                                return _c(
                                  "a",
                                  {
                                    key: genre.id,
                                    staticClass: "a--hover",
                                    attrs: {
                                      href: genre.url,
                                      "data-event-category": "discover",
                                      "data-event-action": "info",
                                      "data-event-label": genre.name
                                    }
                                  },
                                  [_vm._v(_vm._s(genre.name))]
                                )
                              }
                            )
                          ],
                          2
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _vm.dolbyLogos
                    ? _c("img", {
                        staticClass: "dolby-logo ",
                        attrs: {
                          src: _vm.dolbyLogos,
                          alt: "dolby-logo",
                          width: "80"
                        }
                      })
                    : _vm._e()
                ]
              )
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "row",
            class: [_vm.isCollapsed ? "d-md-flex" : "d-md-none"]
          },
          [
            _c(
              "div",
              { staticClass: "col mt-4 mb-4" },
              [
                _c("collaborator-section", {
                  attrs: {
                    video: _vm.video,
                    collaborators: _vm.mergedCollaborators,
                    collapsed: _vm.isCollapsed
                  },
                  on: { clickArrow: _vm.clickArrow }
                }),
                _vm._v(" "),
                _c("DirectorMissingInfo", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isCollapsed,
                      expression: "isCollapsed"
                    }
                  ],
                  staticClass: "missing-info",
                  attrs: { video: _vm.video }
                })
              ],
              1
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass:
              "video__object__info__static__festivals__more d-none d-md-block",
            attrs: { href: "javascript:void(0)" },
            on: { click: _vm.clickArrow }
          },
          [
            _c("span", [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.isCollapsed ? "LESS DETAIL" : "MORE DETAILS") +
                  "\n      "
              )
            ])
          ]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }